function toBase64Url(json) {
    const bytes = new TextEncoder().encode(json);
    let binary = "";
    for (const b of bytes)
        binary += String.fromCharCode(b);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function fromBase64Url(encoded) {
    const padded = encoded.replace(/-/g, "+").replace(/_/g, "/");
    const pad = padded.length % 4 === 0 ? "" : "=".repeat(4 - (padded.length % 4));
    const binary = atob(padded + pad);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++)
        bytes[i] = binary.charCodeAt(i);
    return new TextDecoder().decode(bytes);
}
export function encodePartnershipRequest(payload) {
    return `ITINS-REQ-${toBase64Url(JSON.stringify(payload))}`;
}
export function decodePartnershipRequest(key) {
    const trimmed = key.trim();
    const prefix = "ITINS-REQ-";
    if (!trimmed.startsWith(prefix))
        return null;
    try {
        return JSON.parse(fromBase64Url(trimmed.slice(prefix.length)));
    }
    catch {
        return null;
    }
}
export function buildPartnershipApprovalCode(partnershipId) {
    return `ITINS-OK-${toBase64Url(JSON.stringify({ partnershipId, at: new Date().toISOString() }))}`;
}
export function decodePartnershipApprovalCode(code) {
    const trimmed = code.trim();
    const prefix = "ITINS-OK-";
    if (!trimmed.startsWith(prefix))
        return null;
    try {
        const parsed = JSON.parse(fromBase64Url(trimmed.slice(prefix.length)));
        return parsed.partnershipId ? parsed : null;
    }
    catch {
        return null;
    }
}
export function encodeSubmissionImport(payload) {
    return `ITINS-SUB-${toBase64Url(JSON.stringify(payload))}`;
}
export function decodeSubmissionImport(token) {
    const trimmed = token.trim();
    const prefix = "ITINS-SUB-";
    if (!trimmed.startsWith(prefix))
        return null;
    try {
        return JSON.parse(fromBase64Url(trimmed.slice(prefix.length)));
    }
    catch {
        return null;
    }
}
export function defaultInsuranceHubUrl(override) {
    return override?.replace(/\/$/, "") || "http://localhost:3119";
}
export function partnershipAcceptUrl(requestKey, hubUrl) {
    const base = defaultInsuranceHubUrl(hubUrl);
    return `${base}/partnerships/accept?key=${encodeURIComponent(requestKey)}`;
}
/** Mappe le code assureur Hospitol vers l'organisation hub. */
export function insurerCodeToOrgId(code) {
    const normalized = code.trim().toUpperCase();
    if (normalized === "MUT-SALAMA")
        return "org-mut-salama";
    if (normalized === "ASR-VIE")
        return "org-asr-vie";
    return `org-${normalized.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
}
export function submissionImportUrl(token, hubUrl) {
    const base = defaultInsuranceHubUrl(hubUrl);
    return `${base}/submissions/import?data=${encodeURIComponent(token)}`;
}
export function encodeInvoiceImport(payload) {
    return `ITINS-INV-${toBase64Url(JSON.stringify(payload))}`;
}
export function decodeInvoiceImport(token) {
    const trimmed = token.trim();
    const prefix = "ITINS-INV-";
    if (!trimmed.startsWith(prefix))
        return null;
    try {
        return JSON.parse(fromBase64Url(trimmed.slice(prefix.length)));
    }
    catch {
        return null;
    }
}
export function invoiceImportUrl(token, hubUrl) {
    const base = defaultInsuranceHubUrl(hubUrl);
    return `${base}/invoices/import?data=${encodeURIComponent(token)}`;
}
